<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">
        <div class="StatusNav">
          <ul>
            <li v-for="(item,index) in navlist" v-text="item.name+'('+item.count+')'"
              :class="{'StatusNavActive':item.active}" v-on:click="NavSwitch(item.id)"></li>
          </ul>
        </div>

        <div class="xblock-box">
          <div class="xblock layui-form" :class="{'FloatingNav':SelectedNum > 0}">
            <button class="layui-btn xblock-row" v-on:click="AllEdit">批量编辑<i v-if="SelectedNum > 0"
                v-text="'('+SelectedNum+')'"></i></button>
            <button class="layui-btn xblock-row layui-btn-normal" v-on:click="CreateProduct">手动创建</button>
            <button class="layui-btn xblock-row layui-btn-warm" v-if="ix == 4"
              v-on:click="DeleteItme('all','cancel')">取消定时<i v-if="SelectedNum > 0"
                v-text="'('+SelectedNum+')'"></i></button>
            <button class="layui-btn layui-btn-danger xblock-row" v-on:click="DeleteItme('all')">批量删除<i
                v-if="SelectedNum > 0" v-text="'('+SelectedNum+')'"></i></button>
            <div class="layui-input-inline country_select xblock-row">
              <select name="status" lay-verify="required" lay-filter="shops_selection">
                <option value="0">全部店铺</option>
                <option :value="shop.id" v-text="shop.country+'-'+shop.name" v-for="(shop,index) in shops"
                  v-bind:key="index"></option>
              </select>
            </div>
            <div class="layui-input-inline xblock-row">
              <input type="text" name="username" placeholder="请输入商品货号搜索" v-on:keydown.13="ProductList()"
                autocomplete="off" v-model="sku" class="layui-input" />
            </div>
            <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="ProductList()"><i
                class="fa fa-search"></i></button>
            <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
            <div class="clear-both"></div>
          </div>
        </div>

        <div class="table-box-list">
          <table class="layui-table layui-form layui-table-margin">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" class="cxall" lay-filter="cxall" name="cxall" lay-skin="primary">
                </th>
                <th>图片</th>
                <th>站点</th>
                <th>店铺</th>
                <th>货号</th>
                <th>采集价格</th>
                <th>标题</th>
                <th>状态</th>
                <th v-if="ix == 3">失败原因</th>
                <th>时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody v-viewer>
              <tr v-for="(item,index) in list">
                <td class="cx-box" :data-ix="index">
                  <div><input type="checkbox" lay-filter="cx" lay-skin="primary" :data-index="index"
                      :checked="item.active"></div>
                  <div class="list-number" v-text="index+1"></div>
                </td>
                <td>
                  <div class="table_img">
                    <img :src="item.image">
                  </div>
                </td>
                <td v-text="item.country_zh"></td>
                <td v-text="item.shop_name"></td>
                <td v-text="item.sku"></td>
                <td>
                  <i style="font-size: 13px;" v-if="item.min_price">￥</i><i v-if="item.min_price != item.max_price"
                    v-text="item.min_price+'~'+item.max_price"></i><i v-else v-text="item.min_price"></i>
                </td>
                <td style="min-width: 150px;max-width:400px;word-break:break-all;">
                  <i v-text="item.name"></i>
                </td>
                <td>
                  <div style="width: 80px;">
                    <i v-if="item.type == 1" class="status-box status-box-orange">待发布</i>
                    <i v-else-if="item.type == 2" class="status-box status-box-blue">发布中</i>
                    <i v-else-if="item.type == 3" class="status-box status-box-green">发布成功</i>
                    <i v-else-if="item.type == 5" class="status-box status-box-blue">定时发布</i>
                    <i v-else class="status-box status-box-red">发布失败</i>
                  </div>
                </td>
                <td style="min-width: 150px;max-width:400px;" v-if="ix == 3" v-text="item.error_msg"></td>
                <td v-text="item.created_at"></td>
                <td class="btn-arr">
                  <button class="layui-btn" v-on:click="OpenPage('Edit',item.id)">编辑</button>
                  <button class="layui-btn layui-btn-normal" v-on:click="OpenPage('origin',item.origin)">来源</button>
                  <button v-if="item.item_id" class="layui-btn layui-btn-warm"
                    v-on:click="OpenPage('shopee',item.country,item.item_id,item.shop_id)">在线</button>
                  <button v-if="item.type == 5" class="layui-btn layui-btn-warm"
                    v-on:click="DeleteItme(item.id,'cancel')">取消定时</button>
                  <button class="layui-btn layui-btn-danger" v-on:click="DeleteItme(item.id)">删除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

        <!--scroll to top-->
        <div class="scroll-top">
          <i class="fa fa-angle-up" aria-hidden="true"></i>
        </div>
      </div>

    </div>
    <div class="loading-mask" :isLoding="isLoding" v-if="isLoding"></div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laypage, isRefresh, TimerFun;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Product',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        SelectedNum: 0,
        isLoding: true,
        ix: 0,
        sku: null,
        id: null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num: 20,
        isloding: false,
        list: [],
        navlist: [{
          id: 0,
          count: 0,
          active: false,
          name: "草稿箱",
        }, {
          id: 4,
          count: 0,
          active: false,
          name: "定时发布",
        }, {
          id: 1,
          count: 0,
          active: false,
          name: "发布中",
        }, {
          id: 2,
          count: 0,
          active: false,
          name: "已发布",
        }, {
          id: 3,
          count: 0,
          active: false,
          name: "发布失败",
        }],
        shopid: 0,
        shops: [],
      }
    },
    updated() {
      if (form) {
        form.render();
      }
      self.NumberCheck();
    },
    watch: {
      $route: {
        handler(nv, ov) {
          if (nv.query.id) {
            if (self.id != nv.query.id) {
              self.id = nv.query.id;
              self.list = [];
              self.NavSwitch(0, nv.query.id);
            }
          } else {
            if (self.list.length > 0) {
              $('.pagebox').show();
            }
          }
        }
      },
      deep: true
    },
    beforeDestroy() {
      clearTimeout(TimerFun);
    },
    mounted() {
      self = this;
      self.SetNavActive("上架", self.$route.name);
      let id = self.$route.query.id; //采集商品ID
      let ix = self.$route.query.ix; //导航ID
      scrollTop(); //监听滚动置顶

      //监听浏览器返回
      window.addEventListener("popstate", function(e) {
        if (self.$route.name == "Product") {
          let ix = self.$route.query.ix; //导航ID
          if (ix) {
            self.ix = ix;
            self.NavSwitch(ix);
          }
        }
        event.preventDefault();
      }, false);

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        if (ix) {
          self.ix = ix;
          self.NavSwitch(ix);
        } else {
          self.NavSwitch(0);
        }
        if (id) {
          self.ProductList(id);
        }

        self.get_count();
        self.get_shop_list();
        self.VersionCheck(); //版本检测

        //全选
        form.on('checkbox(cxall)', function(data) {
          var child = $(".cx-box input[type='checkbox']");
          var status = data.elem.checked;
          var num = 0;
          child.each(function(index, item) {
            item.checked = data.elem.checked;
            self.list[index].active = status;
            if (status) {
              num++
            }
          });
          form.render('checkbox');
        });

        //单选
        form.on('checkbox(cx)', function(data) {
          console.log(data)
          let ix = data.elem.dataset.index;
          let status = data.elem.checked;
          self.list[ix].active = status;
          form.render('checkbox');
        });

        //单选
        $("#main-box").on("click", '.cx-box', function(e) {
          var ix = $(this).attr("data-ix");
          if (self.list[ix].active) {
            self.list[ix].active = false;
          } else {
            self.list[ix].active = true;
          }
          form.render('checkbox');
        });

        //店铺选择
        form.on('select(shops_selection)', function(data) {
          self.shopid = data.value;
          self.ProductList();
        });

      });

      $(".layui-body").scroll(function() {
        let scrollTop = $(this).scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      })

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      DeleteItme(id, etype) {
        if (id == "all") {
          if (etype == "cancel") {
            self.Confirm.txt = "是否确定批量取消定时？"
            self.Confirm.te = 'cancel-all';
          } else {
            self.Confirm.txt = "是否确认批量删除？";
            self.Confirm.te = 'del-all';
          }
        } else {
          if (etype == "cancel") {
            self.Confirm.txt = "是否确定取消定时？"
            self.Confirm.te = 'cancel';
          } else {
            self.Confirm.txt = "是否确认删除？"
            self.Confirm.te = 'del';
          }
        }

        self.Confirm.style = 1;
        self.Confirm.state = true;
        self.itemid = id;
      },
      VersionCheck() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/version/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(res) {
          var json = res.data;
          if (json.code == 200) {
            if (json.datas.version != localStorage.getItem("ExShopee_Version")) {
              localStorage.setItem("ExShopee_Version", json.datas.version);
              window.location.reload(true);
            }
          }
        }).catch(function(error) {
          console.log(error);
        })
      },
      ProductList(id) {
        self.list = [];
        let param = new URLSearchParams()
        if (id) {
          param.append('id', id)
        }
        if (self.sku) {
          param.append('sku', self.sku)
        }
        param.append('shop_id', self.shopid)
        param.append('type', self.ix)
        param.append('num', self.page_num)
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + '/get_production_list/?page=' + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.isLoding = false;
          var json = json.data;
          if (json.code == 200) {
            var datas = json.datas;
            var list = datas.list;
            if (datas.page) {
              self.total = datas.total;
              for (let i in list) {
                let max_price = list[i].price[0];
                let min_price = list[i].price[0];
                if (!self.empty(list[i].price[0])) {
                  for (let y in list[i].price) {
                    if (list[i].price[y] > max_price) {
                      max_price = list[i].price[y];
                    }
                    if (list[i].price[y] < min_price) {
                      min_price = list[i].price[y];
                    }
                  }
                  list[i].min_price = min_price;
                  list[i].max_price = max_price;
                }
                list[i].active = false;
              }

              self.list = list;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "ProductList"); //分页
              $('.pagebox').show();
            }
          } else if (json.code == 401) {
            layer.alert('请先前往登录！', {
              title: "ExShopee",
              closeBtn: 0
            }, function() {
              layer.closeAll();
              self.GoToPage("/");
            });
          } else {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.ProductList();
            }
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      OpenPage(url, data, item_id, shop_id) {
        if (url == "origin") {
          window.open(data);
        } else if (url == "shopee") {
          let _url;
          if (data == "TW") {
            _url = "https://xiapi.xiapibuy.com"
          } else {
            _url = "https://" + data + ".xiapibuy.com"
          }
          _url += '/product/' + shop_id + '/' + item_id
          window.open(_url);
        } else {
          self.$router.push({
            path: url + '?id=' + data
          }) // 路由跳转
          localStorage.setItem("ExShopee_EditType", 1);
        }
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (data.state) {
          var ids = [],
            _url = "/product_del_list/";
          if (self.Confirm.te == "del-all" || self.Confirm.te == "cancel-all") {
            for (let i in self.list) {
              if (self.list[i].active) {
                ids.push(self.list[i].id);
              }
            }
          } else {
            ids.push(self.itemid);
          }
          if (self.Confirm.te == "cancel" || self.Confirm.te == "cancel-all") {
            _url = "/task_cancel/";
          }
          self.loading = true;
          self.Confirm.state = false;
          $.ajax({
            url: self.GetServerUrl() + _url,
            type: 'post',
            data: {
              id: JSON.stringify(ids)
            },
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            },
            success: function(res) {
              self.loading = false;
              layer.close(layer.index);
              var json = JSON.parse(res);
              if (json.code == 200) {
                self.ToastFun(0, json.msg); //弹窗提醒
                $('.cxall').prop('checked', false);
                self.ProductList();
                self.get_count();
              } else {
                self.ToastFun(1, json.msg); //弹窗提醒
              }
            },
            error: function(error) {
              self.loading = false;
              self.ToastFun(2, error); //弹窗提醒
            }
          })
        }
      },
      get_shop_list() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            var datalist = datas.list;
            if (datalist.length > 0) {
              self.shops = datalist;
            }
          });

        }).catch(function(error) {
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      get_count() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/p_get_status_number/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            for (let i in self.navlist) {
              self.navlist[i].count = datas.count_arr[i]
            }

            if (datas.count_arr[2] > 0) {
              TimerFun = setTimeout(function() {
                isRefresh = true;
                self.get_count();
              }, 2000)
            } else {
              if (isRefresh) {
                self.ProductList();
                isRefresh = false;
              }
            }
          });

        }).catch(function(error) {
          console.log(error);
        })
      },
      AllEdit() {
        var ids = [];
        for (let i in self.list) {
          if (self.list[i].active) {
            ids.push(self.list[i].id);
          }
        }
        localStorage.setItem("ExShopee_EditIds", JSON.stringify(ids));
        if (ids.length > 0) {
          localStorage.setItem("ExShopee_EditType", 1);
          self.$router.push({
            path: 'Bulk'
          }) // 路由跳转
        } else {
          self.ToastFun(1, "请选择产品！"); //弹窗提醒
        }
      },
      NavSwitch(ix, id) {
        let nix;
        $('.cxall').prop('checked', false);
        self.GoToPage('/Product?ix=' + ix); // 路由跳转
        for (let i in self.navlist) {
          self.navlist[i].active = false;
          if (self.navlist[i].id == ix) {
            nix = i;
          }
        }
        self.navlist[nix].active = true;
        self.ix = ix;
        self.list = [];
        if (id) {
          self.ProductList(id);
        } else {
          self.ProductList();
        }
      },
      CreateProduct() {
        self.$router.push({
          path: "Edit"
        })
      },
      NumberCheck() {
        let num = 0;
        for (let i in self.list) {
          if (self.list[i].active) {
            num++
          }
        }
        self.SelectedNum = num;
        let scrollTop = $(".layui-body").scrollTop();
        if (scrollTop > 30) {
          $(".FloatingNav").css({
            top: 70 + 'px'
          });
        } else {
          $(".FloatingNav").css({
            top: 'auto'
          });
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Product.vue